/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_S1_DescInputs */

const en_landing_how_s1_desc = /** @type {(inputs: Landing_How_S1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the subject, composition and light. Put any words that must appear in quotes.`)
};

const zh_landing_how_s1_desc = /** @type {(inputs: Landing_How_S1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述主体、构图和光线。需要出现的文字请放进引号。`)
};

/**
* | output |
* | --- |
* | "Describe the subject, composition and light. Put any words that must appear in quotes." |
*
* @param {Landing_How_S1_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_how_s1_desc = /** @type {((inputs?: Landing_How_S1_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_S1_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_how_s1_desc(inputs)
	return zh_landing_how_s1_desc(inputs)
});
export { landing_how_s1_desc as "landing.how.s1_desc" }